/**
 * ViewDB 内で 台紙？を識別するためのタグ
 *
 * TODO(micheam): TagID or DaishiID
 */
export class TagID {
  /**
   * 識別子
   */
  public readonly value: string;

  constructor(value: string) {
    this.value = value;
  }

  public equals(that: TagID): boolean {
    return this.value === that.value;
  }

  public toString(): string {
    return `${this.value}`;
  }
}
